import { Injectable } from '@angular/core';
import { AddressService } from './address.service';
import { Address, AddressModel } from 'src/app/models/address/address.model';
import { Observable, ObservableInput, Subject, of, throwError } from 'rxjs';
import { MapsService } from './maps.service';
import { tap, catchError, take } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class BinderAddressService extends AddressService {
	public newAddress$: Subject<Address> = new Subject<Address>();

	constructor(
		protected _mapsService: MapsService,
	) {
		super(_mapsService);
	}

	public getAddresses(address: any): Observable<AddressModel[]> {
		return this.mapsService
			.getGeocoding(address)
			.pipe(
				tap((addressList: AddressModel[]) => {
					if (addressList && addressList.length) {
						addressList.forEach(element => { this.mapAddressModelToAddress(element); });
					}
				}),
				catchError(this.catchError)
			);
	}

	public getAddressPredictions(address: any): Observable<any> {
		return this.mapsService
			.getGeocoding(address)
			.pipe(
				catchError(this.catchError)
			);
	}

	public getAddressesByCoordinates(lat: number, lng: number): Observable<AddressModel[]> {
		return this.mapsService.getGeocodingByCoordinates(lat, lng)
			.pipe(tap(
				(addressList: AddressModel[]) => {
					if (addressList || addressList.length) {
						addressList.forEach(element => { this.mapAddressModelToAddress(element); });
					}
				}),
				catchError(this.catchError)
			);
	}

	public getAddressesByPlaceId(placeId: string): Observable<AddressModel[]> {
		return this.mapsService.getGeocodingByPlaceId(placeId)
			.pipe(tap(
				(addressList: AddressModel[]) => {
					if (addressList || addressList.length) {
						addressList.forEach(element => { this.mapAddressModelToAddress(element); });
					}
				}),
				catchError(this.catchError)
			);
	}

	public attachSubscriber(success: (value: Address) => void, error: (error: any) => void): BinderAddressService {
		this._generalSubscription.add(
			this.newAddress$
				.pipe(take(1))
				.subscribe(success, error)
		);

		return this;
	}

	private catchError(err) {
		return throwError(() => err);
	}

	public use(customConfig: { lookupStates: {}, lookupCountries: {} }): void {
		super.use(customConfig);
	}
}
